import 'css-chunksrc/client/scenes/calendarExportLinks/styles.scss';export default {
  "export": "_export_vpolm_1",
  "exportButton": "_exportButton_vpolm_6",
  "group": "_group_vpolm_12",
  "title": "_title_vpolm_16",
  "exportLink": "_exportLink_vpolm_22",
  "link": "_link_vpolm_35",
  "copyButton": "_copyButton_vpolm_44",
  "copyIcon": "_copyIcon_vpolm_54",
  "container": "_container_vpolm_64",
  "icon": "_icon_vpolm_77"
};